<template>
  <footer class="footer">
    <div class="container">
      <div class="columns">
        <p
          class="column has-text-centered has-text-weight-light">
          <span
            v-html="$t('components.footer.euDisclaimer')">>
          </span>
          <span>
            <img
              src="@/assets/eufinance.jpg"
              alt="Co-financed by the European Union">
          </span>
        </p>

        <p
          class="column has-text-centered"
          v-html="$t('components.footer.contactInfo')">
        </p>

        <!--p
          class="column has-text-centered has-text-weight-light"
          v-html="$t('components.footer.facebookPage')">
        </p-->
      </div>

      <div class="content has-text-centered">
        <p>
          &copy;{{ new Date().getFullYear() }} —
          <strong>
            <a
              href="https://www.minedu.gov.gr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('components.footer.rightsHolder') }}
            </a>
          </strong>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
